import css from 'styled-jsx/css';
import { common } from '../../../theme/theme';

const style = css.global`
  .user-identity-contents {
    width: 380px;
    padding: 16px;
  }
  .label {
    font-size: 14px;
    margin-bottom: 6px;
  }
  .user-identity-title {
    font-size: 16px;
    font-weight: 500;
    font-family: Arial, Helvetica, sans-serif;
    color: black;
    margin-bottom: 10px;
  }
  .user-identity-subtitle {
    font-size: 14px;
    font-weight: 500;
    font-family: Arial, Helvetica, sans-serif;
    color: black;
    padding-top: 15px;
    padding-bottom: 10px;
  }
  .user-identity-input-container {
    width: 100%;
  }
  .user-identity-input-row-container {
    display: flex;
    justify-content: space-between;
  }
  .user-identity-input-container {
    display: flex;
    flex-direction: column;
  }
  .user-switch-wrapper {
    margin-bottom: 3px;
  }
  .user-identity-date {
    width: 100%;
    margin-top: 8px;
    margin-bottom: 8px;
  }
  .button-container {
    padding: 8px 0;
  }
  .user-identity-contents :global(.submit-button) {
    ${common.button}
    ${common.submitButton}
  }
  .user-identity-contents :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
  .error {
    color: red;
    font-size: 11px;
    margin-bottom: 0;
    margin: 4px;
  }
`;

export default style;
